import $ from 'jquery';

export default () => {
    const accordionItems = $('.js-accordion-item');
    const accordionTrigger = $('.js-accordion-trigger');

    if (window.location.hash) {
        const id = window.location.hash.replace('#', '');

        if (accordionTrigger.filter(`[id="${id}"]`).length) {
            accordionTrigger.filter(`[id="${id}"]`).parents('.js-accordion-item').addClass('is-active');
        }
    } else if (accordionItems.attr('data-open') === 'true' && $(window).width() > 1024) {
        accordionItems.addClass('is-active');
    }

    accordionTrigger.on('click', function () {
        const trigger = $(this);
        const item = trigger.parents('.js-accordion-item');
        const headerHeight = $('.js-site-header').outerHeight();

        if (item.hasClass('is-active')) {
            item.removeClass('is-active');
        } else {
            accordionItems.removeClass('is-active');
            item.addClass('is-active');
            if (item.find('.js-events-slider').is('*')) {
                item.find('.js-events-slider').slick('refresh');
            }

            $('html, body').animate({
                scrollTop: item.offset().top - headerHeight
            }, 500);
        }
    });
}



// WEBPACK FOOTER //
// ../src/scripts/modules/accordion.js